
const label =  {
    Username:"Username",
    Submit:"Submit",
    Cancel:"Cancel",
    Back:"Back",
    Or:"Or",
    And:"And",
    Ok:"Ok",
    Edit:"Edit",
    Remove:"Remove",
    Save: "Save",
    Close:"Close",
    Email:"Email",
    Page:"Page",
    Detail:"Detail",
    AddProduct:"Add Product",
    AddInventory:"Add Inventory",
    EnterYourMail:"Enter Your Email",
    YourEmail:"emailanda@email.com",
    Password:"Password",
    ConfirmPassword:"Confirm Password",
    EnterPassword:"Enter Password",
    EnterConfirmPassword:"Enter confirm password",
    EnterOldPassword:"Enter old password",
    EnterNewPassword:"Enter new password",
    ForgetPassword:"Forget Password",
    NotRegisteredYet:"Not registered yet",
    InvalidEmailFormat:"Invalid email format",
    PleaseEnterYourEmailWeWillSendYouInstructionToResetYourPassword:"Please enter your email, we'll send you an instruction to reset your password",


    SelectProduct:"Select Product",
    SelectCabinet:"Select Cabinet",
    SelectSize:"Select Size",
    Sortir:"Order",
    SortBy:"Order By",
    Ascending:"Ascending",
    Descending:"Descending",
    Confirmation:"Confirmation",
    UpdateConfirmationMessage:"The changes are about to be applied. Do you want to proceed with the update?",
    DeleteConfirmationTitle:"Delete Confirmation",
    DeleteConfirmationMessage:"Do you want to delete the selected item",

    Created:"Created",
    Name:"Name",
    BrandName:"Brand Name",
    Heading:"Menu",
    Category:"Sub Menu",
    Updated:"Updated",
    Create:"Create",
    Update:"Update",
    Add:"Add",
    SelectStatus:"Select Status",
    Active:"Active",
    Inactive:"Inactive",
    Expired:"Expired",
    Expiration:"Expiration",
    All:"All",
    AllDevices:"All Devices",
    AllCategories:"All Categories",
    AllStatuses:"All Statuses",
    AllGoods:"All Goods",
    AllInventory:"All Inventory",
    Type:"Type",
    Quantity:"Quantity",
    ComponentQuantity:"Component Quantity",
    Weight:"Weight",
    Price:"Price",
    Fullname:"Fullname",
    Phone:"Phone",

    Search:"Search",
    SearchCreator:"Search creator",
    TypeAndEnterToSearch:"Enter a keyword..",
    SearchByName:"Search by name",
    HashTag:"Hashtag",
    Image:"Image",
    Slug:"Slug",
    Status:"Status",
    SelectAssemblyStatus:"Select Assembly Status",
    SelectInspectionStatus:"Select Inspection Status",
    SelectReleaseVerificationStatus:"Select Release Status",
    ChannelSize:"Channel Size",
    LastStatus:"Last Status",
    PreviousStatus:"Previous Status",
    Warning:"Warning",
    PleaseCompleteTheFields:"Please complete all of the required fields",
    ProductForm:"Product Form",
    UseImageTypeInstruction:(type, size)=>"Use "+type+" image type, with maximum size of file is "+size+" Kb",
    Upload:"Upload",
    EnterProductName:"Enter Product Name",
    EnterQuantity:"Enter Quantity",
    EnterSlug:"Enter Slug",
    EnterWeight:"Enter Weight",
    EnterPrice:"Enter Price",
    EnterPricePerKW:"Enter Price Per KW",
    HoursExpiredAfterCreated:"Expiration Hour Once Created",
    HoursExpiredAfterPaid:"Expiration Hour Once Paid",
    HoursExpiredOnWaitingForPayment:"Expiration Hour Once Waiting For Payment",
    EnterHoursExpiredAfterCreated:"Expiration Hour Once Created",
    EnterHoursExpiredAfterPaid:"Enter Expiration Hour Once Paid",
    EnterHoursExpiredOnWaitingForPayment:"Enter Expiration Hour During A Waiting For Payment",
    AutoSlug:"Auto Slug",
    SelectBrand:"Select Brand",
    SelectHeading:"Select Heading",
    SelectCategory:"Select Category",
    SelectFormType:"Select Form Type",
    RelatedHashTag:"Related HashTag",
    Description:"Description",
    EnterDescription:"Enter Description",
    Size:"Size",
    EnterSize:"Enter Size",
    EnterName:"Enter Name",
    EnterBrandName:"Enter Brand Name",
    CategoryDescription:"Category Description",
    CategoryName:"Category Name",
    EnterCategoryName:"Enter Category Name",
    EnterCategoryDescription:"Enter Category Description",
    EnterProvinceName:"Enter Province Name",
    SelectProvince:"Select Province",
    SelectSmartDeviceType:"Select Smart Device Type",
    EnterCityName:"Enter City Name",
    SelectCity:"Select City",
    EnterDistrictName:"Enter District Name",
    SelectDistrict:"Select District",
    EnterVillageName:"Enter Village Name",
    SelectVillage:"Select Village",
    PostalCode:"Postal Code",
    Creator:"Creator",
    Changer:"Changer",
    ContentOrStockLabel:"Content / Stock",
    SoldStock:"Sold Stock",
    Stock:"Stock",
    StockLog:"Stock History",
    SelectOrder:"Select Order",
    SelectDirection:"Select Direction",
    SelectInOurOut:"Select In / Out",
    SelectStockAuditType:"Select Audit Type",
    StartDate:"Start Date",
    BorrowingDate:"Borrowing Date",
    ResetFilterDate:"Reset Filter Date",
    ReturningDate:"Returning Date",
    EndDate:"End Date",
    CreatedStartDate:"Created Start Date",
    CreatesStartDate:"Creates Start Date",
    CreatedEndDate:"Created End Date",
    CreatesEndDate:"Creates End Date",
    UpdatedStartDate:"Updated Start Date",
    UpdatesStartDate:"Updates Start Date",
    UpdatedEndDate:"Updated End Date",
    UpdatesEndDate:"Updates End Date",
    DataChangesStartDate:"Data Changes Start Date",
    DataChangesEndDate:"Data Changes End Date",
    PrintingStartDate:"Printing Start Date",
    PrintingEndDate:"Printing End Date",
    EnterStartDate:"Enter Start Date",
    EnterEndDate:"Enter End Date",
    Note:"Note",
    View:"View",
    IconClass:"Icon Class",
    EnterIconClass:"Enter Icon Class",
    InventoryForm:"Inventory Form",
    AdminForm:"Admin Form",
    CustomerForm:"Customer Form",
    PointForm:"Point Form",
    VoucherForm:"Voucher Form",
    PopularProduct:"Popular Product",
    LatestProduct:"Latest Product",
    Latest:"Latest",
    OrderQuantity:"Order Quantity",
    SoldOut:"Sold Out",
    Added:"Added",
    EnterBankLabel:"Enter Bank Label",
    EnterBankName:"Enter Bank Name",
    EnterBankCode:"Enter Bank Code",
    EnterAccountBankNumber:"Enter Bank Account Number",
    EnterAccountBankName:"Enter Bank Account Name",
    SMSBankingSenderId:"SMS Banking Sender Id",
    SMSBankingTemplate:"SMS Banking Template",
    EnterSmsBankingSenderId:"Enter Sms Banking Sender Id",
    SMSPrefixIndicator:"SMS Prefix Indicator",
    EnterSMSPrefixIndicator:"Enter SMS Prefix Indicator",
    CurrencyFormat:"Currency Format",
    CurrencyFormatExample:"Example : ##.###,##",
    EnterMobilePhone:"Enter Mobile Phone",
    EnterCustomerReceiverEmail:"Enter Customer Receiver Email",
    EnterSubscriberReceiverEmail:"Enter Subscriber Receiver Email",
    EnterSortir:"Enter Order",
    EnterPageLink:"Enter Page Link",
    TransactionCount:"Transaction Count",
    TransactionDate:"Transaction Date",
    ProductOrderCount:"Product Order Count",
    ProductOrderDate:"Product Order Date",
    FavoriteCount:"Favorite Count",
    CartCount:"Cart Count",
    OriginalPrice:"Original Price",
    FinalPrice:"Final Price",
    Select:"Select",
    Check:"Check",
    CheckAll:"Check All",
    CompanyDescription:"Company Description",
    EnterCompanyDescription:"Enter Company Description",
    VoucherCode:"Voucher Code",
    Owner:"Owner",
    Theme:"Theme",
    Period:"Period",
    Benefit:"Benefit",
    Aggregate:"Aggregate",
    StartPeriod:"Start Period",
    EndPeriod:"End Period",
    SelectPeriod:"Select Period",
    SelectVoucherBenefit:"Select Voucher Benefit",
    SelectPointBenefit:"Select Point Benefit",
    SelectVoucherOwnerType:"Select Voucher Owner Type",
    SelectVoucherDiscountType:"Select Voucher Discount Type",
    SelectAggregateType:"Select Aggregate Type",
    MaxUsage:"Maximum Usage",
    CurrentUsage:"Current Usage",
    Publish:"Publish",
    Unpublish:"Unpublish",
    ValidDay:"Valid Day",
    PurchaseDiscount: "Purchase Discount",
    ShippingDiscount:"Shipping Discount",
    FreeShipping:"Free Shipping",
    PercentageDiscount : "Percentage Discount",
    PriceDiscount : "Price Discount",
    AllTime:"All Time",
    Dynamic:"Dynamic",
    Static:"Static",
    SpecificCustomer:"Specific Customer",
    AnyCustomer:"Any Customer",
    SingleItem:"Single Item",
    JoinItem:"Join Item",
    AnyItem:"Any Item",
    PointExchange:"Point Exchange",
    EnterVoucherCode:"Enter Voucher Code",
    EnterVoucherName:"Enter Voucher Name",
    ThemeColor:"Theme Color",
    AvailableItemForThisVoucher:"Available Item For This Voucher",
    MinimumPurchaseQuantity:"Minimum Purchase Quantity",
    AvailableStock:"Available Stock",
    AvailableItem:"Available Item",
    CustomerWhoHasThisVoucher:"Customer Who Has This Voucher",
    SelectPointType:"Select Point Type",
    PurchaseItemPoin:"Purchase Item Point",
    PurchasePricePoin:"Purchase Price Point",
    PurchasePercentagePoint:"Purchase Percentage Point",
    FixedPoint:"Fixed Point",
    PointBonus:"Bonus Point",
    PurchaseMinimum:"Purchase Minimum",
    ProductItemBelongToThisPoin:"Product Item Belong To This Point",
    RegisteredForThisPoin:"Registered For This Point",
    RegisteredForAnotherPoin:"Registered For Another Point",
    NotRegisteredForAnyPoin:"Not Registered For Any Point",
    PublishConfirmation:"Publish Confirmation",
    UnpublishConfirmation:"Unpublish Confirmation",
    PublishConfirmationMessage:"Do you want to publish this point ?",
    UnpublishConfirmationMessage:"Do you want to unpublish this point ?",
    FlashSaleContent:"Flash Sale Content",
    Inactivate:"Inactivate",
    Activate:"Activate",
    InactivateConfirmation:"Inactivate Confirmation",
    ActivateConfirmation:"Activate Confirmation",
    InactivateFlashSaleConfirmationMessage:"Do you want to inactivate this flash sale ?",
    ActivateFlashSaleConfirmationMessage:"Do you want to activate this flash sale ?",
    SearchProduct:"Search Product",
    FlashSaleStock:"Flash Sale Stock",
    FilterCustomerSearch:"Filter Customer Search",
    RegistrationStartDate:"Registration Start Date",
    RegistrationEndDate:"Registration End Date",
    Gender:"Gender",
    FilterCustomerByTransaction:"Customer Search Filtering By Transaction Filter",
    TransactionStartDate:"Transaction Start Date",
    TransactionEndDate:"Transaction End Date",
    FilterCustomerByProductOrder:"Customer Search Filtering By Order Filter",
    ProductOrderStartDate:"Order Start Date",
    ProductOrderEndDate:"Order End Date",
    MobilePhone:"Mobile Phone",
    TransactionDuring:"Transaction During",
    TransactionFavoriteCartColumnLabel:"Trx/Fav/Cart",
    ProductOrderDuring:"Order During",
    ProductOrderFavoriteCartColumnLabel:"Trx/Fav/Cart",
    Address:"Address",
    CustomerAddress:"Customer Address",
    ListOfDestinationAddress:"List Of Destination Address",
    EnterAddress:"Enter Address",
    Firstname:"Firstname",
    EnterFirstname:"Enter Firstname",
    Lastname:"Lastname",
    EnterLastname:"Enter Lastname",
    EnterEmail:"Enter Email",
    EnterPhoneNumber:"Enter Phone Number",
    BirthDate:"Birth Date",
    EnterBirthDate:"Enter Birth Date",
    SelectGender:"Select Gender",
    TransactionItemQuantity:"Transaction Item Quantity",
    ProductOrderItemQuantity:"Order Item Quantity",
    TotalPay:"Total Payment",

    /**/
    // Product Order Status
    /**/
    Paid:"Paid",
    Packaging:"Packaging",
    Delivery:"Delivery",
    Done:"Done",
    Rejected:"Rejected",
    OnReturn:"OnReturn",
    AcceptedReturn:"Accepted Return",
    Order:"Order",
    /**/
    // End Product Order Status
    /**/

    Payment:"Payment",
    PaymentFee:"PaymentFee",
    ResiAndTracking:"Resi & Tracking",
    Print:"Print",
    PrintSerialNumber:"Print Serial Number",
    PrintAll:"Print All",
    Printed:"Printed",
    SearchByReferenceCode:"Search by reference code",
    YourCustomerCart:"Your Customer Cart",
    RemoveAllCustomerCartConfirmationMessage:"Do you want to remove every customer's cart ?",
    RemoveCustomerCartConfirmationMessage:"Do you want to remove this customer's cart ?",
    RemoveAllCustomerCart:"Remove All Customer Cart",
    RemoveCartRespectively:"Remove Cart Respectively",
    PerCustomer:"Per Customer",
    RemoveHisCart:"Remove Customer Cart",
    SelectType:"Select Type",
    SearchCustomer:"Search Customer",
    CustomerName:"Customer Name",
    SearchAdmin:"Search Administrator",
    Attribute:"Attribute",
    AttributeForm:"Attribute Form",
    Open:"Open",
    OpenPageLink:"Open Pagelink",
    PageLink:"Page Link",
    EnterColorName:"Enter Color Name",
    Hexa:"Hexa",
    EnterLabel:"Enter Label",
    Label:"Label",
    SendEmail:"Send Email",
    SendReceipt:"Send Receipt",
    Subject:"Subject",
    SendAt:"Send At",
    SendAnnouncement:"Send Announcement",

    PublishConfigurationConfirmationMessage:"Do you want to publish this configuration ? Configuration would be implemented to your application runtime",
    ConfigurationDetail:"Configuration Detail",
    PageRow:"Page Row",
    FavoriteRow:"Favorite Row",
    LatestRow:"Latest Row",
    DiscountRow:"Discount Row",
    EnterDiscountRow:"Enter Discount Row",
    FlashSaleRow:"Flash Sale Row",
    EnterFlashSaleRow:"Enter Flash Sale Row",
    SelebgramRow:"Selebgram Row",
    EnterSelebgramRow:"Enter Selebgram Row",
    ImageSize:"Image Size",
    MainProductMaximumRow:"Main Product Maximum Row",
    EnterMainProductMaximumRow:"Enter Main Product Maximum Row",
    EnterCourierApiName:"Enter Courier Api Name",

    FreePaymentFee:"Free Payment Fee",
    BubbleWrapFee:"Bubble Wrap Fee",
    CompanyName:"Company Name",
    EnterCompanyName:"Enter Company Name",
    CompanyPhoneNumber:"Company Phone Number",
    EnterCompanyPhoneNumber:"Enter Company Phone Number",
    ContactPersonPhoneNumber:"Contact Person Phone Number",
    EnterContactPersonPhoneNumber:"Enter Contact Person Phone Number",
    ProductRelatedSize:"Product Related Size",
    EnterProductRelatedSize:"Enter Product Related Size That You Need To Display",
    EnterFavoriteRow:"Enter Favorite Row That You Need To Display",
    EnterLatestRow:"Enter Latest Row That You Need To Display",
    InventoryImageSize:"Maximum Inventory Image Size",
    EnterInventoryImageSize:"Enter Maximum Inventory Image Size",
    VoucherCodeLength:"Voucher Code Length",
    EnterVoucherCodeLength:"Enter Voucher Code Length",
    BankImageDimension:"Bank Image Dimension",
    Width:"Width",
    Height:"Height",
    BrandImage:"Brand Image",
    MidtransMediatorImageDimension:"Midtrans Mediator Image Dimension",
    CourierImageDimension:"Courier Image Dimension",
    ProductImageDimension:"Product Image Dimension",
    TransactionConfiguration:"Transaction Configuration",
    ProductOrderConfiguration:"Order Configuration",
    CourierServiceBaseURL:"Courier Service Base URL",
    EnterCourierServiceBaseURL:"Enter Courier Service Base URL",
    CourierServiceApiKey:"Courier Service Api Key",
    EnterCourierServiceApiKey:"Enter Courier Service Api Key",
    ShippingOriginAddress:"Shipping Origin Address",
    EnterShippingOriginAddress:"Enter Shipping Origin Address",
    SocialMedia:"Social Media",
    EnterHashTag:"Enter #hashtag",
    InstagramLink:"Instagram Link",
    EnterInstagramLink:"Enter Instagram Link",
    FacebookLink:"Facebook Link",
    EnterFacebookLink:"Enter Facebook Link",
    TwitterLink:"Twitter Link",
    EnterTwitterLink:"Enter Twitter Link",
    FacebookApplicationId:"Facebook Application Id",
    EnterFacebookApplicationId:"Enter Facebook Application Id",
    GoogleApplicationId:"Google Application Id",
    EnterGoogleApplicationId:"Enter Google Application Id",
    TawkToReference:"Tawk To Reference",
    EnterTawkToReference:"Enter Tawk To Reference",
    SelectRole:"Select Role",
    ResendPassword:"Resend Password",
    AccessMenu:"Access Menu",
    Menu:"Menu",
    Domain:"Domain",
    ClientKey:"Client Key",
    ServerKey:"Server Key",
    Environment:"Environment",
    PaymentLimitExpiration:"Payment Expiration Limit",
    BankCode:"Bank Code",
    BankAccountNumber:"Bank Account Number",
    BankAccountName:"Bank Account Name",
    SelectBank:"Select Bank",
    BalanceInformation:"Balance Information",
    History:"History",
    BalanceMutation:"Balance Mutation",
    Mutation:"Mutation",
    WithdrawalHistory:"Withdrawal History",
    ReferenceCode:"Reference Code",
    Reference:"Reference",
    Credit:"Credit",
    Debit:"Debit",
    SelectDebitOrCredit:"Select Debit / Credit",
    Amount:"Amount",
    RemainBalance:"RemainBalance",
    WithdrawalConfirmationTitle:"Withdrawal Confirmation",
    RequestWithdrawConfirmationMessage:(amount)=>"You will issued withdrawal with amount "+amount+", " +
        "\nPlease ensure you have entered bank account & account number. " +
        "We will proceed around 2x24 hours. " +
        "Please wait or if you need to ask, do not hestitate to talk with our customer support, Thank You",
    YesIamSure:"Yes Im Sure",
    Sure:"Sure",
    ReCheck:"Recheck",
    WarningWithdrawExist:"You have another incomplete withdrawal request, please wait, Our staff would process it soon",
    Waiting:"Waiting",
    Processing:"Processing",
    Issued:"Issued",
    Postponed:"Postponed",
    StatusHistory:"Status History",
    WithdrawalStatusHistory:"Withdrawal Status History",
    WaitingForPayment:"Waiting For Payment",
    WaitingForSubscriptionPayment:"Waiting For Subscription Payment",
    WaitingForUpgradePayment:"Waiting For Upgrade Payment",
    ExpiredOn:"Expired On",
    Channel:"Channel",
    Account:"Account",
    Total:"Total",
    Tax:"Tax",
    AccountInformation:"Account Information",
    RegisteredOn:"Registered At",
    ActivePeriod:"Active Period",
    YourProductService:"Your Product Service",
    ExtendPeriod:"Extend Period",
    ExtendSubscriptionPeriod:"Extend Subscription Period",
    PayNow:"Pay Now",
    PAY_NOW:"PAY NOW",
    RequestUpgrade:"Request Upgrade",
    REQUEST_UPGRADE:"REQUEST UPGRADE",
    MonthlyPeriod:"Monthly Period",
    Month:"Month",
    Months:"Months",
    Days:"Days",
    Hours:"Hours",
    Minutes:"Minutes",
    Seconds:"Seconds",
    month:"month",
    months:"months",
    days:"days",
    hours:"hours",
    minutes:"minutes",
    seconds:"seconds",
    ProductOption:"Product Option",
    AdditionalPayment:"Additional Payment",
    AdditionalDiscount:"Additional Discount",
    PaymentMethod:"Payment Method",
    ProductInformation:"Product Information",
    ProductName:"Product Name",
    ValidityInformation:"Validity Information",
    ValidFrom:"Valid From",
    ValidUntil:"Valid Until",
    CreateProductSubscribe:"Create Product Subscription",
    Item:"Item",
    PleaseEnterReceiverBankAccountOnYourAccountPage:"Please complete your receiver bank account, it can be complete it on Account Page and only can be accessed by owner !",
    Refresh:"Refresh",
    TotalCustomer:"Total Customer",
    TotalCustomerTransaction:"Total Customer Transaction",
    TotalCustomerProductOrder:"Total Customer Order",
    PreviousMonth:"Previous Month",
    ThisMonth:"This Month",
    PreviousYear:"Previous Year",
    ThisYear:"This Year",
    TotalTransaction:"Total Transaction",
    TotalTransactionAmount:"Total Transaction Amount",
    OnGoingTransaction:"On Going Transaction",
    TotalProductOrder:"Total Order",
    TotalProductOrderAmount:"Total Order Amount",
    OnGoingProductOrder:"On Going Order",
    Date:"Date",
    SelectCriteria:"Select Criteria",
    TotalAmount:"Total Amount",
    BubbleWrapAmount:"Bubble Wrap Amount",
    CourierAmount:"Courier Amount",
    TotalQuantity:"Total Quantity",
    PurchaseItemQuantity:"Purchase Item Quantity",
    EnterYourTicketMessageHereInstruction:"Enter your message here... \nYou can also add an image attachment for more clearly information..",
    Attachment:"Attachment",
    PhysicalServiceAddress:"Physical Service Address",
    PublicDomain:"Public Domain",
    ProductSubscribe:"Product Subscribe",
    ProductSubscribeDetail:"Product Subscribe Detail",
    SubscribePeriod:"Subscribe Period",
    CloudVPS:"Cloud VPS",
    VPSInformation:"VPS Information",
    Yes:"Yes",
    TotalRecord:"Total Record",
    TotalPage:"Total Page",
    YourAccount:"Your Account",
    TakeAPayment:"Take A Payment",
    ExtendNow:"Extend Now",
    DoYouWantToLogoutFormThiApplication:"Do You Want To Logout From This Application ?",
    RegistrationDate:"Registration Date",
    Until:"Until",
    SerialNumber:"Serial Number",
    PrintingExecutor:"Printing Executor",

    Branch:"Branch",
    Title:"Title",
    EnterTitle:"Enter Title",
    FlashSaleName:"Flash Sale Name",
    EnterFlashSaleName:"Enter Flash Sale Name",
    EnterSenderEmail:"Enter Sender Email",
    WhenItCouldBeSent:"When it will be sent ?",
    EnterNoteRecommended:"Enter note (Recommended)",
    EnterMessageForThisUpdate_Recommended:"Enter message for this update (Recommended)",
    EnterReceiptCode:"Enter Receipt Code",
    EnterDailyOperationInAPlainWords:"Enter Daily Operation In Plain Words",
    EnterSettingName:"Enter Setting Name",
    EnterStock:"Enter Stock",
    EnterPercentOfDiscount:"Enter Percent Of Discount",
    ChangePassword:"Change Password",
    OldPassword:"Old Password",
    NewPassword:"New Password",
    Receiver:"Receiver",
    Origin:"Origin",
    Destination:"Destination",
    DailyOperation:"Daily Operation",
    UpdateReceiptCode:"Update Receipt Code",
    SubjectEmail:"Subject Email",
    Base:"Base",
    Api:"Api",
    Simulator:"Simulator",
    EditFlashSale:"Edit Flash Sale",
    CreateFlashSale:"Create Flash Sale",
    Scheduled:"Scheduled",
    MessageForm:"Message Form",
    ReplyFrom:"Reply From",
    SeeTicket:"See Ticket",
    CreateTicket:"Create Ticket",
    InvalidInputOfWaybill:"Invalid Input Of Waybill",
    No:"No",
    VoucherPublishMessage:"Do you want to publish this voucher to your customer ?",
    VoucherUnpublishMessage:"Do you want to unpublish this voucher from your customer ?",
    OriginAddress:"Origin Address",
    StockAllocation:"Stock Allocation",
    Allocation:"Allocation",
    SpecialCloudVPS:"Special Cloud VPS",
    Filter:"Filter",
    DeviceFilter:"Device Filter",
    StatusFilter:"Status Filter",
    AllStatus:"All Status",
    UserFilter:"User Filter",
    CategoryFilter:"Category Filter",
    ModelFilter:"Model Filter",
    AdvanceFilter:"Advance Filter",
    ClickToExpandFilterContent:"Click To Expand Filtering",
    transactionStartDate:"Transaction Start Date",
    transactionEndDate:"Transaction End Date",
    productOrderStartDate:"Order Start Date",
    productOrderEndDate:"Order End Date",
    DestinationProvince:"Destination Province",
    DestinationCity:"Destination City",
    DestinationDistrict:"Destination District",
    DestinationVillage:"Destination Village",
    WithVoucher:"With Voucher",
    EnterNameOrEmailOrPhoneNumberOrRefCodeOrReceiptCode:"Enter name, email, phone number, reference code or receipt code",
    ApplyFilter:"Apply Filter",
    ResetFilter:"Reset Filter",
    Filter:"Filter",
    DownloadExcel:"Download Excel",
    DownloadFile:"File Download",
    Download:"Download",
    DeliveryDuration:"Delivery Duration",
    Main:"Main",
    Profile:"Profile",
    YourProfile:"Your Profile",
    Help:"Help",
    Guide:"Guide",
    Signout:"Signout",
    Message:"Message",
    Ticket:"Ticket",
    ListOfImage:"List Of Image",
    EnterHeadingName:"Enter heading name",
    SearchFlashSaleName:"Search flashsale name...",
    Information:"Information",
    EnterInformation:"Enter Information",
    EmailSubjectCannotBeingEmpty:"Email subject cannot being empty",
    IfYouChooseScheduledModeThenSendAtCannotBeingEmpty:"If you choose schedule mode, then send at field cannot being empty",
    IfYouChooseNonRegularThenSenderFieldCannotBeingEmpty:"If you choose non regular then sender field cannot being empty",
    PleaseEnterAMinimumSingleReceiver:"Please enter a minimum single receiver",
    PleaseEnterTheContentOfThisAnnouncement:"Please enter the content of this announcement",
    DoYouWantToSendThisAnnouncementRightNowPleaseItCannotBePostponed:"Do you want to send this announcement right now, please be careful, it can't be canceled",
    DoYouWantScheduleThisAnnouncementAtTheMomentYouFillInPleaseItCannotBePostponed:"Do you want to make a schedule for this announcement at the time you fill in, please be careful, it can't be canceled",
    RegularSender:"Regular Sender",
    RightNow:"Right Now",
    AllCustomer:"All Customer",
    AllSubscriber:"All Subscriber",
    AnnouncementContentOptions:"Announcement Content Options",
    ManualTyping:"Manual Typing",
    UploadHtmlFile:"Upload Html File",
    CustomerReceiver:"Customer Receiver",
    Sender:"Sender",
    PreviewHtmlContent:"Preview Html Content",
    PreviewContent:"Preview Content",
    WriteYourCSSInline:"Write your CSS inline or on your head tag, so it only need a single file html",
    UseImageWichisAlreadyStoredOnServer:"Use image wich can be accessed by public internet, and insert the src url to image src inline like https://domain.com/image.jpg, " +
        "or you may use also base 64 format",
    ThirdPartyKeys:"Third Party Keys",
    ListMenu:"List Menu",

    AppNameAssembler:"Assembler",

    AppName:"Enetek - Inspection",
    LOGIN:"LOGIN",
    SIGNUP:"SIGNUP",
    UpdateConfirmation:"Update Confirmation",
    Logout:"Logout",
    TotalUser:"Total User",
    TotalInspection:"Total Inspection",
    TotalInspectionDone:"Total Inspection Done",
    TotalTransfer:"Total Transfer",
    OnGoingInspection:"On Going Inspection",
    Pass:"Pass",
    Taken:"Taken",
    NotPass:"Not Pass",
    Closed:"Closed",
    Suspended:"Suspended",
    Opened:"Opened",
    OnWorking:"On Working",
    UserCode:"User Code",
    ModelCategory:"Model Category",
    ProductCategory:"Product Category",
    BalanceOfAllUser:"Balance Of All User",
    PaidAmountOfAllUser:"Paid Amount Of All Users",
    Success:"Success",
    ModelCategoryDetail:"Model Category Detail",
    ProductCategoryDetail:"Product Category Detail",
    MONTHS_LABEL:["January", "February","March","April","May","June","July","Augustus","September","October","November","December"],
    Failed:"Failed",
    ModelCount:"Model Count",
    ModelSize:"Model Size",
    EnterFullname:"Enter Fullname",
    EnterMessage:"Enter Message",
    EnterModelCategoryName:"Enter model category name",
    GenerateAutomatically:"Generate Automatically",
    EnterProductPackageCode:"Enter product package code",
    EnterProductPackageName:"Enter product package name",
    AddModel:"Add Model",
    AddBrand:"Add Brand",
    Fee:"Fee",
    Limitation:"Limitation",
    InspectionLimit:"Inspection Limit",
    User:"User",
    InspectionDone:"Inspection Done",
    Website:"Website",
    Suggestion:"Showing Priority",
    Publication:"Publication",
    Published:"Published",
    Unpublished:"Unpublished",
    ModelList:"Model List",
    GroupForm:"Group Form",
    ReleaseVerificationGroupForm:"Verification Group Form",
    GroupFormDetail:"Detil Grup Form",
    GroupFormList:"Grup Form List",
    AddFormBuilder:"Add Form Builder",
    FormBuilder:"Form Builder",
    FormName:"Form Name",

    Cabinet:"Cabinet",
    CabinetDetail:"Detil Group Cabinet",
    CabinetList:"Group Cabinet List",
    AddCabinet:"Add Cabinet",
    EnterFormName:"Enter Form Name",
    FormPage:"Form page",
    AddFormPage:"Add Form page",

    CabinetRack:"Cabinet Rack",
    AddCabinetRow:"Add Row",
    AddCabinetRack:"Add Rack",
    EnterFormPage:"Enter Form page",
    FormCard:"Form Input",
    AddFormCard:"Add Form Input",
    Tag:"Tag",
    EnterTag:"Enter tag",
    Mandatory:"Mandatory",
    True:"True",
    False:"Tidak",
    UnallowedCharacters:"Non Allowed Characters",
    EnterUnallowedCharacters:"Enter non allowed characters",
    EnterFormType:"Enter form type",
    EnterFormTitle:"Enter form title",
    Placeholder:"Placeholder",
    EnterPlaceholder:"Enter placeholder",
    MaxLength:"Max Length",
    EnterMaxLength:"Enter max length",
    LineCount:"Line Count",
    EnterLineCount:"Enter line count",
    ImageDescription:"Image Description",
    ImageDirectory:"Image Directory",
    ExampleReplacer:"Example replacer",
    ExampleDirectoryFormat:"Example directory format",

    PleaseEnterFormTag:"Please enter a form tag",
    PleaseEnterAFormTitle:"Please enter a form title",
    SaveForm:"Save Form",
    SaveCabinet:"Save Cabinet",
    UserList:"User List",
    Installation:"Installation",
    Installed:"Installed",
    Uninstalled:"Uninstalled",
    SoftwareInstallation:"Software Installation",
    LastOpen:"Last Open",
    EnterReceiverEmail:"Enter receiver emails",
    SlugAlreadyBeenUsed:"Slug already been used",
    CodeAlreadyBeenUsed:"Code already been used",
    Subtitle:"Subtitle",
    EnterSubtitle:"Enter Subtitle",
    PleaseEnterFormName:"Please enter form name",
    PleaseSelectLockerType:"Please select device locker",
    PleaseSelectRFIDReaderType:"Please select RFID reader",
    PleaseSelectParallelPosition:"Please select parallel position",
    PleaseSelectLockerPosition:"Please select locker position",
    PleaseSelectRFIDChannelPosition:"Please select channel position",
    EnterRoleName:"Enter role name",
    EnterMidtransMediatorLabel:"Enter midtrans mediator label",
    EnterMidtransMediatorName:"Enter midtrans mediator name",

    EnterGroupMenu:"Enter group menu",
    EnterQueryKey:"Enter query's key",
    EnterReference:"Enter reference",
    EnterRecommendedInformation:"Enter additional information (Recommended)",
    EnterRecommendedReceiptCode:"Enter receipt code (Recommended)",
    EnterFAQTitle:"Enter FAQ title",
    EnterFAQSubTitle:"Enter FAQ subtitle",
    EnterWebsite:"Enter website",
    EnterBusinessField:"Enter business field",
    EnterBuildDate:"Enter build date",
    EnterCompanyAddress:"Enter company address",
    EnterStartPeriod:"Enter start period",
    EnterEndPeriod:"Enter end period",
    EnterIdCardNumber:"Enter ID Card / Government ID",
    ClickButtonToGenerate:"Click button to generate",
    Organization:"Organization",
    EnterOrganization:"Enter Organization",
    EnterAccountName:"Enter account name",
    AccountName:"Account Name",
    EnterAccountNumber:"Enter account number",
    AccountNumber:"Account Number",
    EnterForSpecificEmailSender:"Enter for specific email sender",
    ModelDetail:"Model Detail",
    ModelInformation:"Model Information",
    TimeValidating:"Time Validating",
    ModelIconRatio:"Model Icon, Dimension 1 (width) x 1 (height)",
    LabelImageAttachmentRatio:"Label attachment, Free Dimension (any x any)",
    InspectionDetail:"Inspection Detail",
    ModelAddressLink:"Model Link Address",
    Platform:"Platform",
    DeviceId:"Device ID",
    FCMToken:"Firebase Cloud Messaging Token",
    Delete:"Delete",
    SearchDeviceId:"Search device id...",

    BackToDashboard:"Back To Dashboard",
    ManufacturingSite:"Manufacturing Site",
    BatchPrint:"Batch Print",
    TokenCode:"Token Code",
    TokenDescription:"This is a token which can be used to verify process under your permission",
    AutoRefresh : "Auto Refresh",
    TimeExpired:"Valid",
    StartSerialNumber:"Start Serial Number",
    EndSerialNumber:"End Serial Number",
    EnterStartSerialNumber:"Enter Start Serial Number",
    EnterEndSerialNumber:"Enter End Serial Number",
    SerialComponent:"Serial Component",
    SerialComponentList:"Serial Component List",
    Value:"Value",
    ManufacturingSiteDetail:"Manufacturing Site Detail",
    EnterManufacturingSiteName:"Enter manufacturing site name",
    PleaseSelectManufacturingSite:"Please select manufacturing site",
    SequenceStartSerialNumber:"Sequence Start Serial Number",
    EnterSequenceStartSerialNumber:"Enter Sequence Start Serial Number",
    Other:"Other",
    Companies:"Companies",
    Company:"Company",
    SelectCompany:"Select Company",
    Stations:"Stations",
    Station:"Station",
    SelectStation:"Select Station",
    GenerateCode:"Generate Code",
    AddLocation:"Add Location",
    AddCompany:"Add Company",
    CompanyForm:"Company Form",
    PriceConfiguration:"Price Configuration",
    ProductOrderPerStation:"Order Per Station",
    SoC:"SoC",
    SoCAvailable:"SoC Available",
    SetSoCAvailability:"Set SoC Availability",
    SuspendedEVToFinishInSecond:"Suspended EV To Finish In Second",
    EnterSuspendedEVToFinishInSecond:"Enter Suspended EV To Finish In Second",
    UnchangingMeterToFinishInSecond:"Unchanging Meter To Finish In Second",
    UnchangingMeterToFinishInFrequent:"Unchanging Meter To Finish In Frequent",
    EnterUnchangingMeterToFinishInSecond:"Enter Unchanging Meter To Finish In Second",
    EnterUnchangingMeterToFinishInFrequent:"Enter Unchanging Meter To Finish In Frequent",
    Module:"Module",
    GroupName:"Group Name",
    CompleteYourRegistrationInformation:"Complete Your Registration Information",
    CompanyInformation:"Company Information",
    Industry:"Industry",
    Verified:"Verified",
    ProductPackage:"Product Package",
    ProductPackageDetail:"Product Package Detail",
    MonthPeriod:"Month Period",
    EnterMonthPeriod:"Enter Month Period",
    EnterSuggestion:"Enter Suggestion",
    FollowUp:"Follow Up",
    FollowUpList:"Follow Up List",
    CompanyType:"Company Type",
    SelectIndustry:"Select Industry",
    AgreeWithTermAndCondition:"Agree with term and condition",
    AgreeWith:"Agree with",
    TermAndCondition:"Term and condition",
    SignUp:"Sign Up",
    VerifyYourMobilePhone:"Verify your mobile phone",
    CheckYourMobilePhoneAt : (mobilePhone) => "Check your mobile phone with number "+mobilePhone,
    OTPCodeSentToYourMobilePhone : (mobilePhone) => "OTP Code sent to your mobile phone : "+mobilePhone,
    WeAreDoingVerifyYourMobilePhone_PleaseFillThisFormWithTheOTPCodeThatWeSendToYourMobilePhone:"We are doing verify your mobil phone, please fill this form with the otp code that we sent to your mobile phone.",
    RegistrationConfirmation:"Registration Confirmation",
    RegistrationSucceed:"Registration Succeed",
    RegistrationSucceedNote:"Thank you for submission, your information has been proceed, please go to sign in page and login with your account authentication",
    PleaseMakeSureYouHaveFulfillTheFormWithCorrectValueWeWillSendToYouOTPCodeToVerifyYourPhoneNumber_PleaseHoldYourPhoneCloseToYouAndVerifyYourPhoneNumberAtTheNextStep:
        "Please make sure you have fulfill the form with correct value, we will send to you OTP code to verify your phone number. " +
        "\nPlease make your phone close to you and verify your phone number at the next step",
    Continue:"Continue",
    PhoneNumberHasAlreadyBeenUsed:"Phone number has already been used",
    UsernameHasAlreadyBeenUsed:"Username has already been used",
    CompanyNameHasAlreadyBeenUsed:"Company name has already ben used",
    WebsiteHasAlreadyBeenUsed:"Website has already been used",
    SomethingUnexpected:"Something unexpected",
    YouWillBeRedirectToLoginPageForMoment:"You will be redirect to login page for a moment",


}
const baru = {
    SearchByCustomerNameOrModelNameOrRefCode:"Search by user, model or ref code...",
    LimitType:"Limit Type",
    Limit:"Limit",
    VerificationType:"Verification Type",
    WorkerVerificationType:"Worker Verification Type",
    InspectionCount:"Inspection Count",
    TotalFee:"Total Fee",
    InspectionReferenceCode:"Inspection Reference Code",
    BrandReferenceCode:"Brand Reference Code",
    StatusHistory:"Status History",
    BrandStatus:"Brand Status",
    ModelApplicationInfo:"Model Application Info",
    SelectVerificationStatus:"Select Verification Status",
    SelectUserStatus:"Select User Status",
    ReferralAgent:"Referral User",
    EverLoggedIn:"Ever Logged In",
    Never:"Never",
    TotalIncome:"Total Income",
    CurrentBalance:"Current Balance",
    CompletedInspection:"Completed Inspection",
    PostponedInspection:"Postponed Inspection",
    IDCard:"ID Card",
    InvalidEmailAddress:"Invalid email address",
    Regenerate:"Regenerate",
    Generate:"Generate",
    UserDetail:"User Detail",
    AddUser:"Add User",
    Location:"Location",
    LastAllocation:"Last Allocation",
    LocationOnMap:"Location On Map",
    OpenInMap:"Open In Map",
    EnterTitleSubtitleSlugBrandOrCategoryToSearch:"Enter title, description, slug, brand, or category to search..",
    SearchNameEmailPhoneUserCodeOrOrganization:"Search name, email, phone, or user code.. ",
    SearchNameOrContainingSerialNumber:"Search by name or containing serial number.. ",
    SearchSerialNumber:"Search by serial number.. ",
    LastOpenStart:"Last Open Start",
    LastOpenEnd:"Last Open End",
    Male:"Male",
    Female:"Female",
    UnrecognizedDueNotAuthenticated:"Unrecognized due not authenticated",
    EnterDeviceIdUserCodeOrNameToSearch:"Enter device id, user code, or name to search..",
    AuthenticatedAsUser:"Authenticated",
    NotAuthenticatedAsUser:"Not Authenticated",
    AuthenticationOption:"Authentication Option",
    ReceiverOption:"Receiver Option",
    NotificationDetail:"Notification Detail",
    SendingConfirmationTitle:"Sending Confirmation",
    DoYouWantToSendThisNotificationWithTheSelectedTopic:"Do you want to send this notification with selected topic?",
    InspectionMustBeingOrderedSequentially:"Inspection should bbe ordered sequentially one by one",
    InspectionCanBeAppliedMoreThanOneSimultaneously:"Inspection can be applied more than one in simultaneously",
    InspectionSubmissionOrder:"Inspection Order",
    MaxUsagePerUser:"Max usage per User",
    MaxInspectionPerUserDefaultUnlimitedPlaceholder:"Max inspection per User (Default 0 for unlimited)",
    MaximumInspectionCanBeApplied:"Maximum inspection can be applied",
    MaximumApplicationUsage:"Maximum Inspection Usage",
    CurrentApplicationUsage:"Current Inspection Usage",
    MaxUsagePerUserCannotBeLargerThanMaxUsageGeneral:"Max inspection per user cannot be larger than general max usage",
    MaxUsageCannotBeSmallerThanCurrentUsage:"Max inspection cannot be smaller than current usage",
    PleaseEnterModelAddressLink:"Please complete model address link",
    PleaseEnterCallbackId:"Please enter callback id",
    PleaseEnterGroupForm:"Please enter group form",
    PleaseEnterModelTimeValidationByAdmin:"Please enter model time validation by admin",
    ModelFee:"Model Fee",
    PleaseEnterModelFee:"Please enter model fee",
    CanBeAppliedByUserVerificationAt:"Can be applied by user verification at",
    CanOnlyBeAppliedByVerifiedUser:"Can onlu be applied by verified user",
    CanBeAppliedByUnverifiedUser:"Can be applied by unverified user",
    TimeApplicationValidationByAdminInHour:"Time Application Validation Process By Admin (In Hour)",
    PleaseEnterDescription:"Please enter description",
    PleaseEnterReferenceDocument:"Please enter additional info",
    ReferenceDocument:"Reference Document",
    MainModelDetail:"Main Model Detail",
    EnterMainModelLabel:"Enter main model label",
    SelectModel:"Select Model",
    MainModelIcon:"Main model icon",
    MultiFinanceDetail:"Multi Finance Detail",
    Label:"Label",
    EnterMultiFinanceLabel:"Enter multi finance label",
    EnterMultiFinanceName:"Enter multifinance name",
    EnterLabelOfInstallmentPeriod:"Enter label of installment period",
    EnterPeriodOfInstallmentPeriod:"Enter installment period",
    InstallmentPeriod:"Installment Period",
    InstallmentPeriodDetail:"Installment Period Detail",
    EnterDiscussionCategoryName:"Enter discussion category name",
    DiscussionCategoryDetail:"Discussion Category Detail",
    AgentFee:"User Fee",
    AgentFeeDetail:"User Fee Detail",
    SelectProductAgent:"Select Product User",
    SelectMultiFinance:"Select MultiFinance",
    AmountFee:"Amount Fee",
    PercentFee:"Percent Fee (%)",
    SelectInstallmentPeriod:"Select Installment Period",
    PreviewCount:"Preview Count",
    ShareCount:"Share Count",
    CommentCount:"Comment Count",
    ReplyCount:"Reply Count",
    Comment:"Comment",
    CommentReply:"Comment Reply",
    ReferenceCodeAlreadyBeenUsed:"Reference code already been used",
    AssemblyWithThisReferenceIsNotFound:"Assembly with this reference is not found",
    CheckNetworkMeter:"Check Network Meter",
    NetworkMeter:"Network Meter",
    NetworkInfoDescriptionInfo:"This test is based on the connectivity between your equipment to the ENQ server host, " +
        "it doesn't give you a guarantee that the connection would be stable with this observation, " +
        "any other problem would be possibility occurs and make this software doesnt work well. " +
        "\n\n" +
        "If you notice some mistake based on this result, please contact Admin IT.",
    RunTest:"Run Test",
    StopTest:"Stop Test",
    ContentSize:"Content Size",
    UploadCSVFile:"Upload CSV File",
    Filename:"File Name",
    Apply:"Apply",
    CSVFileSerialNumberRegulationDescription:"File should be in CSV format type delimiting with ;, which containing 1 header and 2 column that is 1 is No and 2 is serial number",
    ApplyingInspectionResult:"Applying Inspection Result",
    InspectionConfirmDescription:"This process determine whether the inspection part is being exactly applied and following standard." +
        "\n" +
        "Please enter the classification of inspection result below.",
    ApplyingVerificationResult:"Applying Verification Result",
    VerificationConfirmDescription:"This process determine whether the verification is going to be passed or not." +
        "\n" +
        "Please enter conclusion of verification result below.",

    PartName:"Part Name",
    PN:"P/N",
    PartNumber:"Part Number",
    ACInput:"AC Input",
    Frequency:"Frequency",
    ACInputCurrent:"Ac Input Current",
    DCOutput:"DC Output",
    Polarity:"Polarity",
    CORef:"CO Ref",
    Warranty:"Warranty",

    EnterPartName:"Enter Part Name",
    EnterPartNumber:"Enter Part Number",
    EnterPn:"Enter PN",
    EnterACInput:"Enter AC Input",
    EnterFrequency:"Enter Frequency",
    EnterACInputCurrent:"Enter Ac Input Current",
    EnterDCOutput:"Enter DC Output",
    EnterPolarity:"Enter Polarity",
    EnterCORef:"Enter CO Ref",
    EnterTokenToContinue:"Enter Token To Continue",
    EnterToken:"Enter Token",
    Token:"Token",
    Continue:"Continue",
    SuccessfullyCreated:"Successfully Created",
    EnterWarranty:"Enter Warranty",
    Condition:"Condition",
    Container:"Container",
    Containers:"Containers",
    Enabled:"Enabled",
    SmartDevices:"Smart Devices",
    SmartDevice:"Smart Device",
    SmartDeviceDetail:"Smart Device Detail ",
    AddContainer:"Add Container",
    AddSmartDevice:"Add Smart Device",
    ContainerType:"Container Type",
    EnterContainerType:"Enter Container Type",
    QRCode:"QR Code",
    ProductOrderList:"Order List",
    SelectProduct:"Select Product",
    SelectSmartDevice:"Select Smart Device",
    PaymentReference:"Payment Reference",
    PaymentMethod:"Payment Method",
    ProductOrderAmount:"Order Amount",
    ProductOrderDetail: "Order Detail",
    AmountInformation: "Amount Information",
    Purchase:"Purchase",
    Usage:"Usage",
    Remain:"Remain",
    Refund:"Refund",
    OnCharging:"On Charging",
    Canceled:"Canceled",
    PricePerKW:"Price per KW",
    BuyAmount:"Buy Amount",
    AdminFee:"Admin Fee",
    ParkingHour:"Parking Hour",
    ParkingFeeHour:"Parking fee per Hour",
    TotalParkingFee:"Total Parking Fee",
    TotalProductOrderAmount:"Total Order Amount",
    OtherInformation:"Other Information",
    SubPaymentMedia:"Sub Payment Media",
    SubPaymentMediaDetail:"Sub Payment Media Detail",
    SmartDeviceConfiguration:"Smart Device Configuration",
    Key:"Key",
    ReadOnly:"Read Only",
    Original:"Original",
    ResetAll:"Reset All",
    Position:"Position",
    EnterPosition:"Enter Position",
    On:"On",
    Off:"Off",
    Used:"Used",
    Products:"Products",
    SmartDeviceType:"Smart Device Type",
    LockerDevice:"Locker Device",
    RegisteredLockerDevice:"Registered Locker Device",
    EnterSmartDeviceType:"Enter Smart Device Type",
    _24Hours:"24 Hours",
    OpenOperational:"Open",
    CloseOperational:"Close",
    EnterOpenTime:"Enter open time",
    EnterCloseTime:"Enter close time",
    GenerateCode:"Generate Code",
    AddLocation:"Add Location",
    AddCompany:"Add Company",
    CompanyForm:"Company Registration",
    SuccessCallbackUrl:"Success Callback Url",
    FailedCallbackUrl:"Failed Callback Url",
    EnterSuccessCallbackUrl:"Enter Success Callback Url",
    EnterFailedCallbackUrl:"Enter Failed Callback Url",
    HaveUserAccess:"Have User Access",
    HaveAdminAccess:"Have Admin Access",
    Current:"Current",
    ApproveAndCreateOrder:"Approve and Create Order",
    CreateOrder:"Create Order",
    CreateOrderByAdminConfirmation:"Do you want to create order for this customer",
    PleaseEnterCompanyNameCorrectly:"Please enter company name correctly",
    PleaseEnterWebsiteCorrectly:"Please enter website name correctly",
    PleaseSelectIndustry:"Please select industry",
    PleaseSelectCompanyType:"Please select company type",
    PleaseEnterAddressCorrectly:"Please enter address correctly",
    PleaseSelectProvince:"Please select province",
    PleaseSelectCity:"Please select city",
    PleaseSelectDistrict:"Please select district",
    PleaseSelectVillage:"Please select village",
    SignIn:"Sign In",
    SignInNow:"Sign In Now",
    RegisterNow:"Register Now",
    PageNotFound:"Page Not Found",
    PageNotFoundDescription:"The page you want to access is invalid, or something unexpected happen at the system, if you think your destination should exist do not hesitate to contact us",
    InvalidLink:"Invalid Link",
    InvalidLinkDescription:"The link you are seeing is invalid, you may get invalid or expired link.",
    UsernameOrEmail:"Username or Email",
    EnterYourUsernameOrEmail:"Enter your username or email",
    KeepLoggedIn:"Keep logged in",
    SignInToApplication:"Sign in to Application",
    SignInToAssembler:"Sign in to Assembler",
    DontHaveAnAccount:"Don\'t have an account ?",
    HomePage:"Home Page",
    SignInWithRFIDOrFingerPrint:"Sign In with RFID or Fingerprint",
    SignInWithScanner:"Sign In with Scanner",
    SignInWithUsernamePassword:"Sign In with Username",
}

const menu = {
    Dashboard:"Dashboard",
    Account:"Account",
    Product:"Product",
    Brand:"Brand",
    Heading:"Menu",
    Category:"Category",
    ItemProduct:"Item Product",
    Inventory:"Inventory",
    Popular:"Popular",
    Latest:"Latest",
    MainProduct:"Main Product",
    StockAudit:"Stock Audit",
    Program:"Program",
    Discount:"Discount",
    Voucher:"Voucher",
    Point:"Point",
    PointName:"Point Name",
    FlashSale:"Flash Sale",
    Shopper:"Shopper",
    Customer:"Customer",
    Transaction:"Transaction",
    ProductOrder:"Product Order",
    Cart:"Cart",
    Activity:"Activity",
    CustomerActivity:"Customer Activity",
    AdminActivity:"Admin Activity",
    Miscellaneous:"Miscellaneous",
    Banner:"Banner",
    Selebgram:"Selebgram",
    Color:"Color",
    Size:"Size",
    OnlineShop:"Online Shop",
    Branches:"Branches",
    CustomerGuide:"Customer Guide",
    Announcement:"Announcement",
    Broadcast:"Broadcast",
    Subscriber:"Subscriber",
    Administrator:"Administrator",
    Configuration:"Configuration",
    Admin:"Admin",
    Role:"Role",
    UserRole:"User Role",
    PaymentMedia:"Payment Media",
    Bank:"Bank",
    BankAccount:"Bank Account",
    MidtransMediator:"Midtrans Mediator",
    Courier:"Courier",
    Region:"Region",
    Province:"Province",
    City:"City",
    District:"District",
    Village:"Village",
    PaymentTypeCode:"Payment Type Code",
    EnterPaymentTypeCode:"Enter Payment Type Code",
    AmountFee:"Amount Fee",
    PercentFee:"Percent Fee",
    PercentFee:"Percent Fee (%)",
    EnterAmountFee:"Enter Amount Fee",
    EnterPercentFee:"Enter Percent Fee",
    EnterCourierLabel:"Enter Courier Label",
    CourierCode:"Courier Code",
    Code:"Code",
    RequestWithdrawal:"Request Withdrawal",
    TransactionDetail:"Transaction Detail",
    TransactionInfo:"Transaction Info",
    ProductOrderDetail:"Order Detail",
    ProductOrderInfo:"Order Info",
    ResiCode:"Resi Code",
    CourierCost:"Courier Cost",
    Service:"Service",
    TransactionStatus:"Transaction Status",
    ProductOrderStatus:"Product Order Status",
    ItemPrice:"Item Price",
    UniquePrice:"Unique Price",
    BubbleWrap:"Bubble Wrap",
    ShippingAddress:"Shipping Address",
    TransactionItem:"Transaction Item",
    ProductOrderItem:"Order Item",
    TotalPrice:"Total Price",
    Source:"Source",
    TotalWeight:"Total Weight",
    UpdateStatus:"Update Status",
    ChangeStatus:"Change Status",
    CurrentStatus:"Current Status",

    Business:"Business",
    Inspection:"Inspection",
    InspectionScheme:"Inspection Scheme",
    Entities:"Entities",
    InspectionEvent:"Inspection Event",
    AllTasks:"All Tasks",
    Assembly:"Assembly",
    Release:"Release",
    SerialNumber:"Serial Number",
    SubMenu:"Sub Menu",
    Model:"Model",
    FormBuilder:"Form Builder",

    Worker:"Worker",
    QCManagement:"QC Management",
    Devices:"Devices",
    DeviceActivity:"Device Activity",
    UserDevices:"User Devices",
    ConfigurationAdmin:"Admin Configuration",
    ConfigurationEmail:"Email Configuration",
    AdminDevices:"Admin Devices",
    User:"User",
    Verification:"Verification",
    RegHistory:"Reg History",
    Withdraw:"Withdraw",
    WithdrawalRequest:"Withdrawal Request",
    Mutation:"Mutation",
    UserActivity:"User Activity",
    Notification:"Notification",
    ApplicationVersion:"Application Version",
    GoodsCategory:"Goods Category",
    MainModel:"Main Model",
    Reward:"Reward",
    Fee:"Fee",
    MultiFinance:"Multi Finance",
    InstallmentPerio:"Installment Period",
    Discussion:"Discussion",
    DiscussionCategory:"Discussion Category",
    CategoryImage:"Category Image",
    UserPhoto:"User Photo",
    IPAddress:"IP Address",
    UserAgent:"User Agent",
    SystemType:"System Type",
    ModelName:"Model Name",
    Form:"Form",
    EnterSystemType:"Enter system type name / model",
    EnterModelName:"Enter model name",
    Scope:"Scope",
    TestingEquipmentAndAccessories:"Testing Equipment And Accessories",
    SystemSpecification:"System Specification",
    SerialComponent:"Serial Component",
    Value:"Value",
    PassInspection:"Pass Inspection",
    NotPassInspection:"Not Pass Inspection",
    PostponedInspection:"Postponed Inspection",
    SerialCode:"Serial Code",
    InspectionList:"Inspection List",
    BrandCategory:"Category",
    SelectBrandCategory:"Select Category",
    Searching:"Searching",
    SearchReferenceSerialModelUser:"Search reference code, serial code, model, customer, client or user.. ",
    SearchAssemblyByReferenceModelAndUserManufacturingSite:"Search by reference, model name, part name, part number, user and manufacturing site..",
    SearchVerificationByReferenceSerialModelAndUserManufacturingSite:"Search by reference, serial, model name, part name, part number, user and manufacturing site..",
    SearchInspectionByReferenceSerialModelCustomerAndUserManufacturingSite:"Search by reference, serial, model name, part name, part number, customer, user and manufacturing site..",
    SearchReference:"Search by reference code.. ",
    Copy:"Copy",
    CopyToTheNewFormBuilder:(formName) => "Copy ("+formName+") to the new form builder",
    CopyToTheNewForm:(formName) => "Copy ("+formName+") to the new form",
    NewFormBuilderName:"new Form Name",
    EnterNewFormBuilderName:"Enter new form name",
    CreatePage:"Page Creator",
    CreateNewCabinet:"Create New Cabinet",
    CreateCabinetRow:"Cabinet Row Creator",
    CabinetRowTitle:"Cabinet Row Title",
    EnterCabinetRowTitle:"Enter Cabinet Row Title",
    PleaseEnterCabinetRowTitle:"Please enter Cabinet Row Title",
    EnterPageTitle:"Enter page Title",
    PleaseEnterPageTitle:"Please enter page Title",
    ApiDescription:"API Description",
    PositiveLabel:"Positive Label",
    EnterPositiveLabel:"Enter positive label",
    NegativeLabel:"Negative Label",
    EnterNegativeLabel:"Enter negative label",
    HidePrintout:"Hide Printout",
    FormInputConfiguration:"Form Input Configuration",
    ContainerInputConfiguration:"Container Configuration",
    SizeOfRectifierControllerSerialNumber:"Size Of Rectifier/Controller SN",
    SubInput:"Sub Input",
    Type:"Type",
    DoYouWantToRemoveThisFormInput:"Do you want to remove this form input ?",
    DoYouWantToRemoveThisLane:"Do you want to remove this page ?",
    DoYouWantToRemoveThisContainer:"Do you want to remove this container ?",
    DoYouWantToRemoveThisRack:"Do you want to remove this rack ?",
    QualityController:"Quality Controller",
    YourInspectionHistory:"Your Inspection History",
    ThereIsNoHistory:"There is no history",
    NewInspection:"New Inspection",
    NewAssembly:"New Assembly",
    SerialCodeOrReferenceCode:"Serial code or reference code",
    CreateReferenceCode:"Create Reference code",
    SearchInspection:"Search Inspection",
    SearchAssembly:"Search Assembly",
    ContinueInspection:"Continue Inspection",
    ContinueVerification:"Continue Verification",
    InspectionDetailInfo:"Inspection Detail Info",
    CreateNewInspection:"Create New Inspection",
    CreateInspection:"Create Inspection",
    CreateNewAssembly:"Create New Assembly",
    ModelOrSystemType:"Model / System Type",
    ItemInspectionIsNotAvailable:"Itenm Inspection Is Not Available",
    DoYouWantToCreateNewInspection:"Do you want to create a new inspection ?",
    DoYouWantToCreateNewAssemblyPleaseEnterNewReferenceCodeAbove:"Do you want to create a new assembly ? Please enter new reference code above",
    DoYouWantToCreateNewInspectionBasedOnTheAssemblyReferenceCodeAbove:"Do you want to create a new inspection based on the assembly reference above ?",
    AreYouAboutReleasingThisItem:"Are you about releasing this item ?",
    DoYouWantToContinueInspection:"Do you want to continue inspection ?",
    DoYouWantToContinueVerificationProcess:"Do you want to continue verification process ?",
    NewAssemblyHasBeenCreatedDoYouWantToContinueInspection:"New assembler has been created, do you want to continue inspection",
    InspectionItem:"Inspection Item",
    TakingInspectionItem:"Taking Inspection Item",
    ModelInformation:"Model Information",
    CurrentInspectionStatus : "Current Inspection Status",
    PerformedBy : "Performed By",
    CreatedBy : "Created By",
    PreviousInspectionUser:"Previous Inspection User",
    PreviousInspectionPerformedBy:"Previous Inspection Performer",
    PreviousInspectionStatus:"Previous Inspection Status",
    PreviousInspectionDate:"Previous Inspection Date",
    LastInspectionPerformedBy:"Last Inspection Performer",
    LastInspectionDate:"Last Inspection Date",
    LastInspectionStatusDate:"Last Inspection Status Changes Date",
    LastInspectionStatus:"Last Inspection Status",
    CurrentInspectionPerformedBy:"Current Inspection Performed By",
    CurrentInspectionDate:"Current Inspection Date",
    CurrentInspectionStatusDate:"Current Inspection Status Changes Date",
    CurrentInspectionStatus:"Current Inspection Status",
    InspectionStatus:"Inspection Status",
    Next:"Next",
    Previous:"Previous",
    PageNext:"Next >>",
    PagePrevious:"<< Previous",
    InspectionInstruction:"Inspection Instruction",
    InstructionDetail:"Instruction Detail",
    TakePicture:"Take Picture",
    SetPicture:"Set Picture",
    OkIUnderstand:"OK, I Understand",
    RectifierControllerSerialNumber:"Controller/Rectifier Serial Number",
    RectifierSerialNumber:"Rectifier Serial Number",
    ConfirmCancellation:"Confirm Cancellation",
    ConfirmSubmission:"Confirm Submission",
    ScanTheSerialNumber:"Scan The Serial Number",
    ScanTheReference:"Scan The Reference",
    OrEnterItManually:"Or Enter It Manually",
    YouWillSubmitInspectionWithReferenceVariable1AndSerialCodeVariable2WithStatusVariable3_AreYouSure : (reference, serialCode, status) =>
        "You are about to submit inspection with a reference code that is<br/><strong><h3>"+reference+"</h3></strong>" +
        "and serial number<br/><strong><h3>"+serialCode+"</h3></strong>and inspection status become<strong><h3>"+status+"</h3></strong><p>, are you sure with your intention ?</p>",
    YouWillCloseInspectionWithReferenceVariable1AndSerialCodeVariable2_AreYouSure : (reference, serialCode, status) =>
        "You are about to close inspection with a reference code that is<br/><strong><h3>"+reference+"</h3></strong>" +
        "and serial number<br/><strong><h3>"+serialCode+"</h3></strong>and inspection status become<strong><h3>"+status+"</h3></strong><p>, are you sure with your intention ?</p>",
    YouWillPostponeInspectionWithReferenceVariable1AndSerialCodeVariable2_AreYouSure : (reference, serialCode, status) =>
        "You are about to postpone inspection with a reference code that is<br/><strong><h3>"+reference+"</h3></strong>" +
        "and serial number<br/><strong><h3>"+serialCode+"</h3></strong><p>This action will cause this inspection unable to taken by another user ?</p>",
    YouWillSuspendInspectionWithReferenceVariable1AndSerialCodeVariable2_AreYouSure : (reference, serialCode, status) =>
        "You are about to suspend inspection with a reference code that is<br/><strong><h3>"+reference+"</h3></strong>" +
        "and serial number<br/><strong><h3>"+serialCode+"</h3></strong><p>This action will cause this inspection unable to taken by any user ?</p>",

    YouWillPostponeReleaseWithReference_AreYouSure : (reference) =>
        "<strong>You are about to postpone this release with a reference code that is</strong><br/><strong><h2 class=\'text-danger bold\'>"+reference+"</h2></strong>" +
        "</h3></strong><p>This action will cause this release unable to taken by any other user ?</p>",
    YouWillCloseReleaseWithReferenceVariable1_AreYouSure : (reference, status) =>
        "You are about to close this release with a reference code that is<br/><strong><h3>"+reference+"</h3></strong>" +
        "and inspection status become<strong><h3>"+status+"</h3></strong><p>, are you sure with your intention ?</p>",
    YouWillSubmitReleaseVerificationWithReferenceVariableWithStatusVariable3_AreYouSure : (reference, status) =>
        "You are about to submit a release with a reference code that is<br/><strong><h2 style='color: red'>"+reference+"</h2></strong>" +
        "</strong>and verification status become<br/><strong><h3>"+status+"</h3></strong><p>do you confirm ?</p>",
    YouWillSuspendVerificationWithReferenceVariable1_AreYouSure : (reference) =>
        "You are about to suspend a release with a reference code that is<br/><strong><h3>"+reference+"</h3></strong>" +
        "<p>This action will cause this release unable to taken by any user, do you confirm ?</p>",

    YesImSure:"Yes, Im sure",
    PleaseEnterValue:"Please enter this field value",
    PleaseEnterAFieldValueVariable : (variableName) => "Please enter "+variableName,
    EnterMessageIfYouNeedTo:"Enter message if you need to",
    EnterNoteIfYouNeedTo:"Enter note if you need to",
    InspectionMessage:"Inspection Message",
    InspectionNote:"Inspection Note",
    Preview:"Preview",
    PreviewInvoice:"Preview Invoice",
    FormInspectionDetail:"Form Inspection Detail",
    CloseStatusAndPrint:"Close Status & Print",
    ClickToExpandMoreInformation:"Click to expand more information",
    CLoseStatus:"Close",
    SuccessUpdatingStatus:"Success Updating Status",
    FailedUpdatingStatus:"Failed Updating Status",
    Reprint:"Reprint",
    Checking:"Checking",
    CheckingList:"Checking List",
    UserStatus:"User Status",
    AdminStatus:"Admin Status",
    CheckingHistory:"Checking History",
    CheckingActivity:"Checking Activity",
    PostponeInspection:"Postpone Inspection",
    PostponeVerification:"Postpone Verification",
    InspectionOrderedSequentially:"Inspection ordered sequentially",
    SelectSystemType:"Select System Type",
    OpenedInspection:"Opened Inspection",
    NA:"NA",
    ApplicationSetting:"Application Setting",
    TimePerform:"Time Perform",
    Reason:"Reason",
    Searching:"Searching",
    UpdateProfile:"Update Profile",
    SuspendInspection:"Suspend Inspection",
    SuspendRelease:"Suspend Release",
    Reopen:"Reopen",
    DoYouWantToReopenThisInspection_ThisActionWillCauseTheInspectionCouldBeTakenByAnyUser:"Do you want to reopen this inspection ?\nThis action causes this inspection able to be taken by other user, do you confirm ?",
    DoYouWantToReopenThisRelease_ThisActionWillCauseTheReleaseAbleToBeTakenByAnyUser:"Do you want to reopen this release ?\nThis action causes this release able to be taken by other user, do you confirm ?",
    ContinueReOpenInspection:"Continue Reopen Inspection",
    ReOpenInspection:"Reopen Inspection",
    ReOpenVerification:"Reopen Verification",
    PleaseEnterFirstName:"Please enter a valid firstname",
    PleaseEnterSmartDeviceLabel:"Please enter smart device label",
    PleaseEnterSmartDeviceName:"Please enter smart device name",
    PleaseEnterSmartDeviceNameCorrectly:"Please enter smart device name correctly",
    PleaseEnterSmartDeviceLabelCorrectly:"Please enter smart device label correctly",
    PleaseEnterFullName:"Please enter your fullname",
    PleaseGenerateARefCodeForThisUser:"Please generate reference code for this user",
    PleaseGenerateUsername:"Please generate username for this user",
    PleaseEnterEmail:"Please enter a valid email",
    PleaseEnterEmailToGenerateUsername:"Please enter a valid email to generate a username",
    PleaseSelectRoleForThisUser:"Please select role for this user",
    PleaseSelectRoleForThisAdmin:"Please select role for this admin",
    PleaseEnterARightMobilePhone:"Please enter valid mobile phone",
    PleaseEnterPhoneNumberCorrectly:"Please enter valid phone number (with country code)",
    DoYouWantToCreateANewUser:"Do you want to create a new user ?",
    DoYouWantToCreateANewAdmin:"Do you want to create a new admin ?",
    DoYouWantToUpdateInformationOfThisUser:"Do you want to update information of this user ?",
    DoYouWantToUpdateInformationOfThisAdmin:"Do you want to update information of this admin ?",
    SuccessUpdatingData:"Success updating data",
    SuccessDeletingData:"Success deleting data",
    DoYouWantToResendAPasswordForThisUser:"Do you want to resend a password for this user ?",
    DoYouWantToResendAPasswordForThisAdmin:"Do you want to resend a password for this admin ?",
    SuccessSendingThePassword:"Success sending the password",
    DoYouWantToUpdateThisUserStatusFrom : (previousStatus, nextStatus) => "Do you want to update this user status from "+previousStatus+" to "+nextStatus,
    DoYouWantToUpdateThisAdminStatusFrom : (previousStatus, nextStatus) => "Do you want to update this admin status from "+previousStatus+" to "+nextStatus,
    Reason:"Reason",
    StatusHistory:"Status History",
    BanThisDevice_TheUserWillBeBannedAfterThisPerform:"Ban This Device, The user will be banned from the application after this perform, are you sure ?",
    BanThisDevice_TheAdminWillBeBannedAfterThisPerform:"Ban This Device, The admin will be banned from the application after this perform, are you sure ?",
    ApplicationSetting:"Application Setting",
    Sequence:"Order",
    TimeActivity:"Time Activity",
    TimePerform:"Time Perform",
    ProvincePage:"Province Page",
    AdminDetailInformation:"Admin Detail Information",
    AdministratorInformation:"Administrator Information",
    CreateNewAdmin:"Create New Admin",
    AdminCode:"Admin Code",
    NeverEnd:"Never End",
    Periodic:"Periodic",
    NoLimit:"No Limitation",
    Limited:"With Limitation",
    PleaseAddAMinimumSingleForm:"Please make at least a single form",
    PleaseEnterGroupFormName:"Please enter group form name",
    PleaseAddAMinimumSingleContainer:"Please make at least a single container",
    PleaseEnterCabinetName:"Please enter group form name",
    PleaseEnterPositiveLabel:"Please enter positive label",
    PleaseEnterNegativeLabel:"Please enter negative label",
    PleaseEnterPlaceHolder:"Please enter placeholder",
    NEVER_END:"Never End",
    PERIODIC:"Periodic",
    NO_LIMIT:"No Limitation",
    LIMITED:"With Limitation",
    CustomerOrderNo:"Customer Order No",
    Client:"Client",
    ProductSKU:"Product SKU",
    ProductName:"Product Name",
    Controller:"Controller",
    FWVersion:"FW Version",
    ControllerInfo:"Controller Info",
    CustomerInfo:"Customer Info",
    CustomerInformation:"Customer Information",
    EnterCustomerOrderNo:"Enter customer order no",
    BatchPrintInfo:"Batch Print Info",
    EnterBatchPrintName:"Enter batch print name",
    EnterSerialNumberRangeToPrint:"Enter serial number range to print",
    EnterClient:"Enter client",
    EnterProductSKU:"Enter product SKU if available",
    EnterProductName:"Enter product name If available",
    OrderNo:"Order No",
    Instruction:"Instruction",
    DoYouWantToChangeYourPassword:"Do you want to change your password ?",
    OldPasswordMustBeEntered:"Old password must be entered",
    NewPasswordMustBeEntered:"New Password must be entered",
    ConfirmPasswordMustBeEntered:"Confirm password must be entered",
    PasswordMustAtLeastContain6Characters:"Password should contain at least 6 characters",
    OldPasswordAndNewPasswordCannotBeSame:"Old password and new password cannot be same",
    ConfirmPasswordAndNewPasswordIsNotSame:"Confirm password and new password are'nt same",
    SelectInspectionStatus:"Select Inspection Status",
    SameSerialCodeInformation:"Same Serial Number Information",
    FailedToSendInspection:"Failed To Send Inspection",
    FailedToUpdateVerification:"Failed To Update Verification",
    AvailableCameraDeviceList:"Available Camera Device List",
    SuccessCreatingInspection:"Success Creating Inspection",
    Performer:"Performer",
    FirstPerformer:"First Performer",
    LastPerformer:"Last Performer",
    PreviousPerformer:"Previous Performer",
    TimeAgo_future: "in %s",
    TimeAgo_past: "%s ago",
    TimeAgo_s: 'a few seconds',
    TimeAgo_m: "a minute ago",
    TimeAgo_mm: "%d minutes ago",
    TimeAgo_h: "an hour ago",
    TimeAgo_hh: "%d hours ago",
    TimeAgo_d: "a day ago",
    TimeAgo_dd: "%d days ago",
    TimeAgo_M: "a month ago",
    TimeAgo_MM: "%d months ago",
    TimeAgo_y: "a year ago",
    TimeAgo_yy: "%d years ago",
    Time_future: "in %s",
    TimeFuture_next: "%s next",
    TimeFuture_s: 'a few seconds',
    TimeFuture_next_m: "a minute later",
    TimeFuture_next_mm: "%d minutes later",
    TimeFuture_next_h: "an hour later",
    TimeFuture_hh: "%d hours later",
    TimeFuture_d: "a day later",
    TimeFuture_dd: "%d days later",
    TimeFuture_M: "a month later",
    TimeFuture_MM: "%d months later",
    TimeFuture_y: "a year later",
    TimeFuture_yy: "%d years later",
    LastModification:"Last Modification",
    DocumentNumber:"Document Number",
    EnterDocumentNumber:"Enter document number",
    PleaseEnterDocumentNumber:"Please enter document number",
    NewDocumentNumber:"New document number",
    EnterNewDocumentNumber:"Enter new document number",
    PleaseEnterNewDocumentNumber:"Please enter new document number",
    InternalPrint:"Internal Print",
    ExternalPrint:"External Print",
    SuccessUpdatingInspection:"Success Updating Inspection",
    SuccessSavingInspection:"Success Saving Inspection",
    SuccessSavingARelease:"Success Saving a Release",
    SuccessUpdatingData:"Success Updating Data",
    SaveInspection:"Save Inspection",
    SaveVerification:"Save Verification",
    SelectMedia:"Select Media",
    OptimizingYourImage:"Optimizing the image...",
    DeviceCameraIsNotSupportedPleaseCheckYourCameraPermissionOrUseAnotherWebBrowser:"Device camera is not supported by this browser, please check your camera permission or use another web browser",
    InspectionEventDetail:"Inspection Event Detail",

    // start configuration admin
    EnterHostMail:"Enter your host email",
    PleaseEnterHostMail:"Please enter a valid host email",

    EnterPortMail:"Enter your port email",
    PleaseEnterPortMail:"Please enter a valid port email",

    EnterUsernameMail:"Enter your username email",
    EnterUsername:"Enter username",
    PleaseEnterUsernameMail:"Please enter a valid username email",

    EnterPasswordMail:"Enter your password email",
    PleaseEnterPasswordMail:"Please enter a valid password email",

    EnterReplyToMail:"Enter your email reply",
    PleaseEnterReplyToMail:"Please enter a valid reply email",

    EnterFromMail:"Enter your email from",
    PleaseEnterFromMail:"Please enter a valid email",

    DoYouWantToUpdateInformationOfConfigurationAdmin:"Do you want to update information of this configuration ?",
    TestSendMail:"Test Send Email",
    NotificationEmailSent:"Notification Email Sent",
    Resend:"Resend",
    CompanyType:"Company Type",
    AllocatedDeviceId:"Allocated Device Id",
    PaymentProof:"Payment Proof",
    ControlStatus:"Status Control",
    SeeAll:"See All",
    SubscribedService:"Subscribed Service",
    Trying:"Trying",
    NewOrder:"New Order",
    InventoryType:"Inventory Type",
    AllRegistered:"All Registered",
    SinceLastMonth:"Since last month",
    TodayActivity:"Today Activity",
    WeeklyActivity:"Weekly Activity",
    Top5UsageRank:"Top 5 Usage Rank",
    CurrentProductOrderList:"Current Product Order List",
    SeeOrderDetail:"See Order Detail",
    SummaryOfOrder:"Summary Of Order",
    RequestProcess:"Request To Process",
    UpdatedAt:"Updated At",
    SeeInvoice:"See Invoice",
    SeeReceipt:"See Receipt",
    SelectImage:"Select Image",
    Apply:"Apply",
    CropImage:"Crop Image",
    PaymentInformation:"Payment Information",
    UploadPaymentProof:"Upload Payment Proof",
    SelectImageToUpload:"Select Image To Upload",
    CannotDeletePaymentProof:"Cannot remove this payment proof",
    PaymentGuideline:"Payment Guideline",
    TransferAsPaymentMethod:"Transfer As Payment Method",
    PaymentGuidelineDescription:"Pay through bank and account number shown above,\n" +
        "                          fill the reference or not with reference code, save the slip. Then contact to confirm your payment.",
    RequestToProcessTitle:"Are you sure about this request",
    RequestToProcessDescription:"You are requesting process to the system, please make sure that you made a payment or contact us to get information for any required action.",
    ProductOrderStatusHistory:"Order Status History",
    HistoryOfYourProductOrder:"History of your order",
    Service:"Service",
    SessionAndActivity:"Session & Activity",
    Oldest:"Oldest",
    Latest:"Latest",
    TheMost:"The Most",
    Smallest:"Smallest",
    State:"State",
    Action:"Action",
    DownloadSoftware:"Download Software",
    Restart:"Restart",
    DeviceInformation:"Device Information",
    UUID:"UUID",
    PublicIpAddress:"Public IP Address",
    LocalIpAddress:"Local IP Address",
    ShortCode:"Short Code",
    ContainerAvailability:"Container Availabity",
    NoInformation:"No Information",
    PleaseFillUpDeviceLocated:"Please fill up a device located",
    Management:"Management",
    Showing:"Showing",
    Entries:"Entries",
    Entry:"Entry",
    OutOf:"Out Of",
    Regional:"Regional",
    CreateLocation:"Create Location",
    LocationInformation:"Location Information",
    BuildDate:"Build Date",
    BuildingInformation:"Building Information",
    PhoneNumber:"Phone Number",
    SelectLocation:"Select Location",
    Reset:"Reset",
    UpdateConfirmationDetailMessage:"Please ensure information that you are entering fit's to your purpose, do you want to continue with the update ?",
    SelectCalendar:"Select Calendar",
    PleaseSelectYourPlaceGeoLocation:"Please select your place geo location",
    LocationList:"Location List",
    CompanyLocationList:"Company Location List",
    ClientLocationList:"Client Location List",
    LastAccess:"Last Access",
    UpdateInformation:"Update Information",
    GeneralInformation:"General Information",
    ChangePhoto:"Change Photo",
    UserSession:"User Session",
    TotalAuthenticatedDevice:"Total Authenticated Device",
    Last5UserActivity:"Last 5 Activities",
    LastActivity:"Last Activity",
    PleaseEnterCorrectPhoneNumber:"Please enter correct phone number",
    PleaseEnterCorrectEmail:"Please enter correct email",
    PleaseEnterAddress:"Please enter address",
    YourProfilePage:"Your Profile Information",
    CreateUser:"Create User",
    CreateUserAccount:"Create User Account",
    UserCreationPasswordNote:"User will get temporary password on their email, and will use it for authentication. They will get asked to change their password once they authenticated.",
    NeverAccessing:"Never Accessing",
    NoActivitiesFound:"No activities found",
    SelectAtLeastOneRole:"Select at least one role",
    Latest5SmartDeviceHavingActivity : (count) => "Latest "+count+" Smart Devices having activity ",
    Latest10UserActivity : "Latest 10 User activity ",
    Latest20UserActivity : "Latest 20 User activity ",
    LogoutConfirmation:"Logout Confirmation",
    BackToSignIn:"Back to sign in page",
    WeWillSendYourPasswordOnForgetPasswordMessage:"We will give you some instruction through your valid registered email",
    PleaseRememberYourPasswordAsItIsImportantToYourAccessToApplicationAndDoNotShareWithAnyOtherPerson:"Please remember your new password as its important to you to access application and do not share with any other person.",
    RequestToChangePasswordRequiredIsExistsToEnterApplication:"Request to change password is exists to enter application",
    ResetPasswordSucceed:"Reset Password Succeed",
    ResetPasswordSucceedNote:"Thank you for doing change password well, please go to sign in page and login with using your authentication.",
    SuccessUpdatingYourPassword:"Success updating your password",
    RegisteredSince:"Registered Since",
    RegisteredUntil:"Registered Until",
    PleaseSelectCompany:"Please select company",
    PleaseSelectProduct:"Please select product",
    PleaseSelectPackage:"Please select package",
    PleaseAddAtLeastOneOrderItem:"Please add at least one order item",
    Welcome:"Welcome",
    UseUsernameOrEmailToSignIn:"Use Username Or Email To Sign In",
    UseRFIDOrFingerprintToSignIn:"Use RFID Tag or fingerprint to Sign In",
    ScanYourRFIDOrFingerprint:"Scan your RFID or Fingerprint",
    WhatWouldYouDo:"What would you do",
    Home:"Home",
    Starting:"Starting",
    LocationName:"Location Name",
    GoodsCategoryDetail:"Goods Category Detail",
    Goods:"Goods",
    GoodsList:"Goods List",
    RegisteredItem:"Registered Item",
    RegisterItem:"Register Item",
    CreateGoods:"Create Goods",
    CreateGoodsForm:"Create Goods Form",
    GoodsName:"Goods Name",
    EnterGoodsName:"Enter Goods Name",
    GoodsDescription:"Goods Description",
    EnterGoodsDescription:"Enter Goods Description",
    More:"More",
    SeeAllItem:"See All Item",
    Register:"Register",
    NewItem:"New Item",
    ScanTag:"Scan Tag",
    StartScanning:"Start Scanning",
    StopScanning:"Stop Scanning",
    NotOnScanningMode:"Not on scanning mode",
    ScanningRFIDOnAReader:"Scanning RFID on a reader",
    RegisterTagForGoodsItem:"Register Tag For Goods Item",
    RFIDTag:"RFID Tag",
    RFIDTag_OnTheGo:"RFID Tag (Reader)",
    RFIDTag_EnterManually_PressScanButtonToRetrieveItFromReaderMachine:"RFID Tag (Enter Manually) / Press scan button to retrieve from reader machine",
    LengthDoesntFollowTheRuleOfTag:"Length doesn't follow the rule of Tag",
    AvailableMedia:"Available Media",
    Storage:"Storage",
    MediaStorage:"Media Storage",
    TakingPictureMedia:"Taking Picture Media",
    RegisterImageForGoodsItem:"Register Image For Goods Item",
    RegisterImage:"Register Image",
    GoodsItemList:"Goods Item List",
    GoodsInformation:"Goods Information",
    EnterGoodsCategory:"Enter Goods Category",
    GoodsInfoForm:"Goods Information Form",
    GoodsCategoryCreation:"Goods Category Creation",
    Rows:"Rows",
    Pages:"Pages",
    SelectGoodsCategory:"Choose Goods Category",
    Exclusive:"Exclusive",
    CreateCategory:"Create Category",
    NotYetAllocated:"Not Yet Allocated",
    UpdateRfidTag:"Update RFID Tag",
    Executor:"Executor",
    DateTime:"DateTime",
    Models:"Models",
    GoodsInfo:"Goods Info",
    GoodsInfoDetail:"Goods Info Detail",
    GoodsItem:"Goods Item",
    GoodsItemDetail:"Goods Item Detail",
    Goods:"Goods",
    Registered:"Registered",
    Borrowed:"Borrowed",
    Placed:"Placed",
    Returned:"Returned",
    RemovedFromMachine:"Removed From Machine",
    ToolBox:"ToolBox",
    SelectUser:"Select User",
    Selected_Count : (count) => "Selection ("+count+")",
    LockerDeviceParallelPosition:"Device Parallel Position",
    LockerPosition:"Locker Position",
    MaximumContainerSizeReached:"Maximum container size has been reached",
    Locker:"Locker",
    RFIDReaderDevice:"RFID Reader Device",
    RFIDReaderParallelPosition:"RFID Reader Parallel Position",
    RFIDChannelPosition:"RFID Channel Position",
    Placement:"Placement",
    UploadPaymentReceipt:"Upload Payment Receipt",
    PaymentReceiptNeededToRequestProcessing:"Payment receipt needed to continue request processing",
    MaxBorrowingDuration:"Max Borrowing Duration",
    PerHour:"Per Hour",
    NotLimited:"Not Limited",
    Limited:"Terbatas",
    VendingMachine:"Vending Machine",
    Borrowing:"Borrowing",
    Missing:"Missing",
    BorrowingList:"Borrowing List",
    SupportTicket:"Support Ticket",
    TakenFrom:"Taken from",
    ReturnedOn:"Returned On",
    Borrower:"Borrower",
    Returner:"Returner",
    Time:"Time",
    BorrowingInformation:"Borrowing Information",
    UserInformation:"User Information",
    BorrowingTime:"Borrowing Time",
    ReturningTime:"Returning Time",
    BorrowingSmartDevice:"Borrowing Device",
    ReturningSmartDevice:"Returning Device",
    BorrowingPhysicalContainer:"Borrowing Container",
    ReturningPhysicalContainer:"Returning Container",
    ShouldReturnedAt:"Should Returned At",
    Returning:"Returning",
    LastLocation:"Last Location",
    RegistrationList:"Registration List",
    Registration:"Registration",
    NewRegistration:"New Registration",
    SucceedCreatingNewRegistration:"Succesfully creating new registration",
    HelpVerification:"Help Verification",
    CompleteData:'Complete Data',
    SearchLocation:"Search Location",
    CompanySubscription:"Company Subscription",
    SubscriptionList:"Subscription List",
    CreateNewOrder:"Create New Order",
    LastUpdate:"Last Update",
    SomeOfSubscriptionGonnaExpiredAlert:"One of your subscription is going to be expired, take extend of period before its been expired soon",
    SomeOfSubscriptionIsExpiredAlert:"Some of your subscription is expired, you can extend before system move its status become inactive",
    ActivePeriod:"Active period",
    RemainingActivePeriod:"Remaining Active Period",
    OnBorrow:"On Borrow",
    BorrowingOfItemList:"Borrowing Of Item List",
    FormCreation:"Form Creation",
    UploadFile:"Upload File",
    APKFile:"APK File",
    MiscellaneousFile:"Miscellaneous File",
    Filename:"Filename",
    Whatsapp:"Whatsapp",
    BusinessContact:"Business Contact",
    PleaseSelectLocation:"Please select location",
    UpdateSmartDevice:"Pembaruan Smart Device",
    ComponentSize:"Component Size",
    RectifierControllerSize:"Rectifier / Controller Size",
    RectifierAndControllerSize:"Rectifier And Controller Size",
    RectifierController:"Rectifier / Controller",
    ComponentGroup:"Component Group",
    ComponentGroupSelection:"Component Group Selection",
    ComponentGroups:"Component Groups",
    AddComponentGroup:"Add Component Groups",
    ComponentGroupDetail:"Component Group Detail",
    AddItem:"Add Item",
    ComponentInformation:"Component Information",
    ComponentItem:"Component Item",
    ComponentItems:"Component Items",
    Item:"Item",
    CharacterLengthDefault : (length) => "Character Length (Default "+length+")",
    CharacterLength:"Character Length",
    EnterCharacterLength:"Enter Character Length",
    Length:"Length",
    AddAtLeastOneComponentToGroup:"Add at least a component to the group",
    SelectComponentGroup:"Select Component Group",
    PleaseSelectComponentGroup:"Please select a component group",
    PleaseSelectGroupForm:"Please select a group form",
    PleaseSelectReleaseVerificationGroupForm:"Please select release verification group form",
    ModelProperties:"Model Properties",
    BasicInformation:"Basic Information",
    FormInformation:"Form Information",
    Component:"Component",
    MasterComponent:"Master Component",
    ComponentList:"Daftar Komponen",
    EnterComponentName:"Enter Component Name",
    EnterComponentDescription:"Enter Component Descripton",
    PleaseEnterALabel:"Please enter a label",
    PleaseEnterADescription:"Please enter a description",
    PleaseEnterACharacterLength:"Please enter a character length",
    AssemblyOrAction:"Assembly/Action",
    ComponentAndRectifier:"Component/Rectifier",
    ComponentAndRectifierInformation:"Component and Rectifier Information",
    ThisModelWillRequireYouToProvideComponentCountAndRectifierCount: (componentSize, rectifierSize) => "This model will require you to provide "+componentSize+" component information and "+rectifierSize+" controller / rectifier serial numbers to be fulfilled at your assembly works",
    ANewAssemblyWillBeGeneratedWithTheReferenceCodeYouProvided_PleaseKindlyTakeItIntoConsideration : "A new assembly will be generated with the reference code you provided. Please kindly take it into consideration.",
    CreateNewAssembly:"Create Assembly",
    ReferenceCodeFormatYYYYFollowingWith6RunningNumbers:"Code format is YYYY + 6 unique running numbers",
    CreateNewAssemblyConfirmation:"Create a new assembly confirmation",
    SuccessfullyUpdatingNewData:"Successfully updating new data",
    Assemblies:"Assemblies",
    CreatingDate:"Creating Date",
    UpdatingDate:"Updating Date",
    SelectModelCategory:"Select Model Category",
    Of_Size_ModelCategories : (size) => "Of "+size+" Model Categories",
    Of_Size_ModelCategory : (size) => "Of "+size+" Model Category",
    AssemblyHistories:"Assembly Histories",
    AssemblyHistoryDetail:"Assembly History Detail",
    AssemblyDetail:"Assembly Detail",
    AssemblyInformation:"Assembly Information",
    AssemblyFormSubmission:"Assembly Form Submission",
    ContinueAssemblyConfirmation:"Continue Assembly Confirmation",
    ConfirmSubmission:"Confirm Submission",
    TheAssemblyHasBeenDone:"The assembly has been done",
    TheAssemblyHasBeenPostponed:"The assembly has been postponed",
    TheAssemblyHasBeenSuspended:"The assembly has been suspended",
    TheAssemblyHasBeenReturnedByQC:"The assembly has been returned by QC",
    TheAssemblyHasBeenSubmitted:"The assembly has been submitted",
    YourAssembly:"Your Assembly",
    Take:"Take",
    OnGoingAssemblies:"On Going Assemblies",
    QuickLookupEnterAReference_InspectionSerialNumber_ComponentSerial_Number:"Quick lookup.. enter a reference, inspection or component serial number",
    CreateAssembly:"Create Assembly",
    LookupAssemblies:"Lookup Assemblies",
    RecordNotFound:"Record not found",
    InspectionCreation:"Inspection Creation",
    Index:"Index",
    ModelPhoto:"Model Photo",
    LabelPhoto:"Label Photo",
    From:"From",
    FormType:"Form Type",
    PleaseSelectFormType:"Please select a form type",
    Outgoing:"Outgoing",
    OnProgress:"On Progress",
    QuickLookupSearchByReferenceOrSerialCode:"Quick lookup.. enter a reference or serial number",
    SearchByReferenceOrSerialCode:"Search by reference or serial number",
    ReferenceOrSerialCode:"Reference or serial number",
    ReleaseCreation:"Release Creation",
    WithReference:"With a reference",
    JustHaveBeen : "Just have been",
    HaveBeen : "Have been",
    CreateRelease: "Create Release",
    Keyword:"Keyword",
    ReleaseVerificationDetail:"Release Verification Detail",
    ReleaseStatus:"Release Status",
    Performers:"Performers",
    ListOfRelease:"List Of Release",
    PostponeRelease:"Postpone Release",
    ContinueVerification:"Continue Verification",
    VerificationHistory:"Verification History",
    VerificationOf:"Verification Of ",
    InspectionEventHistory:"Inspection Event History",
    YouHaveIncompleteInput:"You have some incomplete input's, please check it",
    YouHaveSomeIssueOnTheInputForm_PleaseCheckItAccordingly:"You have some issue's on the input form, please check it",
    CreateFromScratch:"Create From Scratch",
    GenerateFromInspection:"Generate From Inspection",
    AssemblyGenerationFromInspectionWarningMessage:"<b>The assembly generation</b> can <u>only works</u> if <b style='color:darkred'>the assembly reference hasn't been created yet, while the reference inspection exists</b>. Otherwise please <u>create the assembly from scratch</u>, or find the assembly from the <u><b>Assembly Menu</b></u>.",
    FindReferenceOrSerialFromExistingInspection:"Find by reference or serial number from existing inspection",
    CreateAssemblyFromInspectionDescriptionInfo:"Inspection has been found with no assembly exists, do you want to generate assembly for this inspection ?",
    SearchModelByNameSystemAndPart:"Search by name, system or part number..",
    ViewInspection:"View Inspection",
    ReleaseVerification:"Release Verification",
    CannotHaveUncheckedForBothDashboardAndOutgoingDescription:"Cannot have unchecked for both Dashboard and Outgoing Page, as one of them must become a main page on its application, please check at least one of them",
    Field:"Field",
    EN:"EN",
    ID:"ID",
    Language:"Language",
    Site:"Site",
    FW:"FW",
    Signature:"Signature",
    Draw:"Draw",
    YouDontHaveQCPassStampPleaseUpdate:"You dont have QC Pass stamp yet, please update!",
    YouDontHaveSignaturePleaseUpdate:"You dont have signature yet, please update!",
    DrawYourDigitalSignatureBelow:"Draw your digital signature below",
    DigitalSignature:"Digital Signature",
    QCPassStamp:"QC Pass Stamp",
    PickImage:"Pick Image",

}
module.exports = Object.freeze(Object.assign(label, menu, baru))

